import {createVar, style, fallbackVar, keyframes} from "@vanilla-extract/css";
import {calc} from "@vanilla-extract/css-utils";
import {layoutStyles} from "../../css/layout.css";
import {colorThemeVars} from "../../css/themes/themes.css";
import {styleArray} from "../../css/css-utils";

const vars = {
  size: createVar(),
  strokeWidth: createVar(),
  color: createVar(),
  secondaryColor: createVar(),
};

export const iconVars = vars;

export const iconStyles = {
  base: style([
    layoutStyles.flex.none,
    {
      fill: "none",
      width: vars.size,
      height: vars.size,
    },
  ]),
  type: {
    stroke: style({
      fill: "none",
      stroke: fallbackVar(iconVars.color, "currentColor"),
      strokeWidth: vars.strokeWidth,
    }),
    fill: style({fill: fallbackVar(iconVars.color, "currentColor")}),
    strokeWithFill: style({
      stroke: fallbackVar(iconVars.color, "currentColor"),
      strokeWidth: vars.strokeWidth,
      fill: fallbackVar(vars.secondaryColor, "transparent"),
    }),
    secondaryFill: style({
      fill: fallbackVar(vars.secondaryColor, "transparent"),
    }),
  },
  mode: {
    inline: style([
      layoutStyles.display["inline-block"],
      layoutStyles.position.relative,
      {
        marginTop: calc(vars.size).divide(4).negate().toString(),
        top: calc(vars.size).divide(4).add("-1px").toString(),
      },
    ]),
    block: style([layoutStyles.display.block]),
  },
  sizes: {
    16: style({
      vars: {
        [vars.strokeWidth]: `${(24 / 16) * 1.25}px`,
        [vars.size]: "16px",
      },
    }),
    20: style({
      vars: {
        [vars.strokeWidth]: `${((24 / 20) * 1.5).toFixed(1)}px`,
        [vars.size]: "20px",
      },
    }),
    24: style({
      vars: {
        [vars.strokeWidth]: "1.75px",
        [vars.size]: "24px",
      },
    }),
  },
  setSize: styleArray(["10px", "12px", "14px", "30px", "48px"], (val) => ({
    vars: {[vars.size]: val},
  })),
  setStrokeWidth: styleArray(["1.25px"], (val) => ({vars: {[vars.strokeWidth]: val}})),
};

export const spinAnim = keyframes({
  "0%": {transform: "rotate(0deg)"},
  "100%": {transform: "rotate(360deg)"},
});

export const spinnerStyles = {
  bg: style({fill: fallbackVar(colorThemeVars.border.default)}),
  spinner: style({
    animation: `${spinAnim} 2s infinite linear`,
    transformOrigin: "50% 50%",
  }),
  gradientStop: style({stopColor: colorThemeVars.text.primary}),
};
